import { render } from "./ResetPassword.vue?vue&type=template&id=05d6755a&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=05d6755a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d6755a"],['__file',"src/components/auth/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05d6755a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05d6755a', __exports__)) {
    api.reload('05d6755a', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=05d6755a&scoped=true", () => {
    api.rerender('05d6755a', render)
  })

}


export default __exports__